import { useState } from "react";
import Chart from "react-apexcharts";
import "./DashboardHealth.css";

const DashboardHealth = () => {
  const [options] = useState({
    chart: {
      height: 350,
      type: "line",
      zoom: false,
      toolbar: {
        show: false,
      },
    },

    dataLabels: {
      enabled: false,
    },
    stroke: {
      colors: ["#077AFF"],
      curve: "smooth",
    },
    xaxis: {
      labels: {
        show: false,
      },
      axisBorder: {
        show: false,
      },
      axisTicks: {
        show: false,
      },
    },
    yaxis: {
      labels: {
        show: false,
      },
    },
    grid: {
      padding: {
        top: -35,
        right: 0,
        bottom: -30,
        left: 0,
      },
      show: false, // you can either change hear to disable all grids
    },
    legend: {
      show: false,
    },
  });
  const [series] = useState([
    [
      {
        data: [20, 41, 35, 51, 49, 62, 50, 30, 50],
      },
    ],
    [
      {
        data: [20, 41, 35, 51, 49, 30, 50, 30, 90],
      },
    ],
  ]);
  return (
    <div className="dashboardHealth">
      <ul className="dashboardHealth__items">
        <li className="dashboardHealth__item down flex-column">
          <div className="dashboardHealth__itemHeader flex-row">
            <div>
              <h3>125</h3>
              <span>Total Games</span>
            </div>
            <div className="flex-row">
              <div className="dashboardHealth__itemIndicator"></div>
              <span className="dashboardHealth__itemPercent">86%</span>
            </div>
          </div>
          <Chart
            options={{
              ...options,
              stroke: {
                colors: ["#ea3943"],
                curve: "smooth",
              },
              colors: ["#ea3943"],
            }}
            series={series[0]}
            type="line"
            height={35}
          />
        </li>
        <li className="dashboardHealth__item up flex-column">
          <div className="dashboardHealth__itemHeader flex-row">
            <div>
              <h3>98</h3>
              <span>Total Wins</span>
            </div>
            <div className="flex-row">
              <div className="dashboardHealth__itemIndicator"></div>
              <span className="dashboardHealth__itemPercent">145%</span>
            </div>
          </div>
          <Chart
            options={{
              ...options,
              stroke: {
                colors: ["#28c76f"],
                curve: "smooth",
              },
              colors: ["#28c76f"],
            }}
            series={series[1]}
            type="line"
            height={35}
          />
        </li>
        <li className="dashboardHealth__item up flex-column">
          <div className="dashboardHealth__itemHeader flex-row">
            <div>
              <h3>48</h3>
              <span>Top 10s</span>
            </div>
            <div className="flex-row">
              <div className="dashboardHealth__itemIndicator"></div>
              <span className="dashboardHealth__itemPercent">91%</span>
            </div>
          </div>
          <Chart
            options={{
              ...options,
              stroke: {
                colors: ["#28c76f"],
                curve: "smooth",
              },
              colors: ["#28c76f"],
            }}
            series={series[1]}
            type="line"
            height={35}
          />
        </li>
        <li className="dashboardHealth__item normal flex-column">
          <div className="dashboardHealth__itemHeader flex-row">
            <div>
              <h3>$0.00</h3>
              <span>Total Budget</span>
            </div>
            <div className="flex-row">
              <div className="dashboardHealth__itemIndicator"></div>
              <span className="dashboardHealth__itemPercent">112%</span>
            </div>
          </div>
          <Chart
            options={{
              ...options,
              stroke: {
                colors: ["#ffb800"],
                curve: "smooth",
              },
              colors: ["#ffb800"],
            }}
            series={series[0]}
            type="line"
            height={35}
          />
        </li>
      </ul>
    </div>
  );
};

export default DashboardHealth;
